import { IDetailsGroupRenderProps } from '@fluentui/react';
import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * This hook generates the general props for grouping behavior for the
 * details list. It mainly handles collapse behavior.
 */
export const useSearchGroupProps = ({
  collapsedGroups,
  setCollapsedGroups,
  isAllGroupsCollapsed,
  setIsAllGroupsCollapsed,
}: MakeGroupPropsProps): IDetailsGroupRenderProps => {
  const [t] = useTranslation(['translation']);
  return {
    showEmptyGroups: true,
    headerProps: {
      expandButtonProps: {
        title: t('Expand/Collapse Group'),
      },
      styles: {
        headerCount: {
          display: 'none',
        },
      },
      onToggleCollapse: group => {
        if (collapsedGroups) {
          if (collapsedGroups.indexOf(group?.key) === -1) {
            setCollapsedGroups([...collapsedGroups, group?.key]);
          } else {
            setCollapsedGroups([
              ...collapsedGroups.filter(g => g !== group?.key),
            ]);
          }
        }
      },
    },
    isAllGroupsCollapsed,
    onToggleCollapseAll: () => {
      setIsAllGroupsCollapsed(c => !c);
      if (isAllGroupsCollapsed) {
        setCollapsedGroups([]);
      }
    },
  };
};

export interface MakeGroupPropsProps {
  collapsedGroups: Partial<string>[];
  setCollapsedGroups: (groupKeyList: string[]) => void;
  isAllGroupsCollapsed: boolean;
  setIsAllGroupsCollapsed: Dispatch<SetStateAction<boolean>>;
}
